import { render, staticRenderFns } from "./main-last-played.vue?vue&type=template&id=491afe7a&scoped=true"
import script from "./main-last-played.vue?vue&type=script&lang=js"
export * from "./main-last-played.vue?vue&type=script&lang=js"
import style0 from "./main-last-played.vue?vue&type=style&index=0&id=491afe7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491afe7a",
  null
  
)

export default component.exports